'use client';

import { useCallback } from 'react';

import { config } from '@/config/config';
import { useSearchParams } from '@/hooks/use-search-params.hook';
import { PersistedUserNavigationSearchParams } from '@/types/enums/persisted-user-navigation-search-params.enum';
import {
  buildPathWithQuery,
  buildUrlWithPersistedParams,
} from '@/utils/persisted-params.util';

export interface BuildAgendamentoLinkOptions {
  path: string;
  query?: Record<string, string | string[]>;
  overrides?: Partial<Record<string, string | null>>;
}

export function useAgendamentoNavigation() {
  const baseUrl = config.ag.url ?? '';
  const searchParams = useSearchParams(Object.values(PersistedUserNavigationSearchParams));

  const buildLink = useCallback(
    (options: BuildAgendamentoLinkOptions): string => {
      const { path, query, overrides } = options;
      const pathWithQuery = buildPathWithQuery(path, query);
      const fullPath = pathWithQuery.startsWith('/')
        ? pathWithQuery
        : `/${pathWithQuery}`;
      const absoluteUrl = `${baseUrl.replace(/\/$/, '')}${fullPath}`;
      const paramsRecord = Object.fromEntries(
        Object.values(PersistedUserNavigationSearchParams).map((key) => [key, searchParams[key] ?? null]),
      ) as Record<string, string | null>;
      return buildUrlWithPersistedParams({ baseUrl: absoluteUrl, overrides, searchParams: paramsRecord });
    },
    [baseUrl, searchParams],
  );

  return {
    buildLink,
  };
}
